/** Commerce 列表：伺服器分頁與右下角每頁筆數選項（與後端上限 100 對齊） */
export const COMMERCE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

export const COMMERCE_DEFAULT_PAGE_SIZE = 20;

/**
 * @param {object} opts
 * @param {number} opts.page
 * @param {number} opts.pageSize
 * @param {number} opts.total
 * @param {(page: number, pageSize: number) => void} opts.onChange
 * @param {(total: number) => React.ReactNode} [opts.showTotal]
 */
export function commerceServerTablePagination({ page, pageSize, total, onChange, showTotal }) {
  return {
    current: page,
    pageSize,
    total,
    showSizeChanger: true,
    pageSizeOptions: COMMERCE_PAGE_SIZE_OPTIONS,
    showTotal: showTotal ?? ((t) => String(t)),
    onChange: (p, ps) => onChange(p, ps ?? pageSize),
    onShowSizeChange: (p, ps) => onChange(p, ps)
  };
}
